/* eslint-disable */

function dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) { byteString = atob(dataURI.split(',')[1]); } else { byteString = unescape(dataURI.split(',')[1]); }

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
}

function canvasToBlobUrl(canvas) {
    const blob = dataURItoBlob(canvas.toDataURL('image/png'));
    return window.URL.createObjectURL(blob);
}

export default function warpWebGl(id, matrix1, matrix2) {
    // try to create a WebGL canvas (will fail if WebGL isn't supported)
    let canvas = null;
    try {
        canvas = window.fx.canvas(1080, 1080);
    } catch (e) {
        return;
    }

    // convert the image to a texture
    const imageEl = document.getElementById(id);

    const image = new Image();

    image.src = imageEl.src;

    return new Promise((resolve) => {
        image.onload = function () {

            const texture = canvas.texture(image);

            const bbox1 = {
                nw: {
                    x: matrix1[0],
                    y: matrix1[1]
                },
                ne: {
                    x: matrix1[2],
                    y: matrix1[3]
                },
                se: {
                    x: matrix1[4],
                    y: matrix1[5]
                },
                sw: {
                    x: matrix1[6],
                    y: matrix1[7]
                }
            },
                bbox2 = {
                    nw: {
                        x: matrix2[0],
                        y: matrix2[1]
                    },
                    ne: {
                        x: matrix2[2],
                        y: matrix2[3]
                    },
                    se: {
                        x: matrix2[4],
                        y: matrix2[5]
                    },
                    sw: {
                        x: matrix2[6],
                        y: matrix2[7]
                    }
                };

            const matrix1Xs = [];
            const matrix1Ys = [];

            for (var i = 0; i < matrix1.length; i += 2) {
                matrix1Xs.push(matrix1[i])
            }

            for (var i = 1; i < matrix1.length; i += 2) {
                matrix1Ys.push(matrix1[i])
            }

            const matrix1northmost = Math.min.apply(null, matrix1Ys);
            const matrix1southmost = Math.max.apply(null, matrix1Ys);
            const matrix1westmost = Math.min.apply(null, matrix1Xs);
            const matrix1eastmost = Math.max.apply(null, matrix1Xs);

            const matrix2Xs = [];
            const matrix2Ys = [];

            for (var i = 0; i < matrix2.length; i += 2) {
                matrix2Xs.push(matrix2[i])
            }

            for (var i = 1; i < matrix2.length; i += 2) {
                matrix2Ys.push(matrix2[i])
            }

            var matrix2northmost = Math.min.apply(null, matrix2Ys),
                matrix2southmost = Math.max.apply(null, matrix2Ys),
                matrix2westmost = Math.min.apply(null, matrix2Xs),
                matrix2eastmost = Math.max.apply(null, matrix2Xs);

            var offsetX = matrix2westmost - matrix1westmost;
            var offsetY = matrix2northmost - matrix1northmost;

            canvas.draw(texture,
                image.width,//  * ratio,
                image.height// * ratio
            );




            var ratioY = (matrix2southmost - matrix2northmost)
                / (matrix1southmost - matrix1northmost);

            var ratioX = (matrix2eastmost - matrix2westmost)
                / (matrix1eastmost - matrix1westmost);

            var ratio = Math.max(ratioX, ratioY);

            // stretch output matrix x to fix:
            // for (var i = 0; i < matrix2.length; i += 2) {
            //   matrix2[i] -= offsetX;
            //   matrix2[i] /= ratio;
            // }

            // // stretch output matrix y to fix:
            // for (var i = 1; i < matrix2.length; i += 2) {
            //   matrix2[i] -= offsetY;
            //   matrix2[i] /= ratio;
            // }

            canvas.perspective(matrix1, matrix2).update();

            // replace the image with the canvas
            // image.parentNode.insertBefore(canvas, image);
            // image.parentNode.removeChild(image);

            const canvas2 = document.createElement('canvas');
            canvas2.width = 1000;
            canvas2.height = 630;
            const context = canvas2.getContext("2d");
            context.drawImage(
                canvas,
                0,
                0,
                1000,
                630,
                0,
                0,
                1000,
                630
            );

            const imageData = context.getImageData(
                0,
                0,
                1000,
                600,
            );

            const { data } = imageData
            const pixel = [];
            let rgb = 0;
            let dark = 0;
            let light = 0;
            const len = data.length / 4;
            for (let i = 0; i < data.length; i++) {
                if (i % 4 === 3) {
                    if (rgb > 240) {
                        light++;
                    } else if (rgb < 104) {
                        dark++;
                    }
                    rgb = 0;
                    continue;
                }
                rgb += accumalte(i % 4, data[i]);
            }

            console.log('light / pixel.length', light / len)

            if (light / len > 0.02) {
                resolve('LIGHT');
            } else if (dark / len > 0.9) {
                resolve('DARK');
            } else {
                var burl = canvasToBlobUrl(canvas2);
                resolve(burl);
            }
        }
    });
}

const maps = {
    0: 0.299,
    1: 0.587,
    2: 0.114,
}

function accumalte(i, value) {
    const ratio = maps[i];
    return ratio * value;
}

//  0 1 2 3 4 5 6 7 8